import styled from 'styled-components';

const Container = styled.div`
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  margin: auto;
  background-color: ${(props) => (props.bg ? props.bg : '')};
`;

export default Container;
